<template>
  <div class="fff">
    <Header />
    <!-- <Aside /> -->
    <div class="banner"></div>
    <div class="container">
      <div class="course">
        <div class="header"></div>
        <div class="category-list">
          <div :class="['item',item.id == categoryId?'active':'']" v-for="item,index in categoryData" :key="index" @click="currentId(item)">{{ item.name }}</div>
        </div>
        <div class="course-list">
          <div class="item" v-for="item,index in courseData" :key="index" @click="goClassDetails(item)">
            <div class="item-cover">
              <img :src="item.photo">
            </div>
            <div class="item-info">
              <div class="info-title"><span>{{ item.name }}</span></div>
            </div>
          </div>
          <div class="visible"></div>
          <div class="visible"></div>
        </div>
        <div class="hangkeBase pages" v-if="this.courseData.length > 0">
          <a-pagination :defaultPageSize="size" @change="onChange" :locale="zhCN" :default-current="1" :total="total" :current="currentPage" />
        </div>
      </div>
     
    </div>
    <Footer />
  </div>
</template>
<script>
import zhCN from "ant-design-vue/es/locale-provider/zh_CN";
import Header from "@/components/hangke/Header"
import services from "../../config/services"
import utils from "../../config/utils"
import { mapState } from "vuex"
import projectData from "../../assets/js/projectData.js"
// import Aside from "../../components/Custom/Party/Aside.vue"
export default {
  data () {
    return {
      zhCN,
      school_code: utils.getUrlSchoolCode(window.location.pathname) || localStorage.getItem("schoolCode"),
      num: 0,
      currentPage: 1,
      size: 20,
      total: 0,
      services: services,
      categoryData: [],
      courseData: [],
      courseInfo: {
        total: 0,
        total_time: "00:00:00",
      },
      categoryId: "",
      studyBan: false,
    }
  },
  components: {
    Header,
  },
  mounted () {
    // utils.setTitle(this.projectList[this.$route.query.index].name)
    // this.showHtml = this.background // 默认展示背景
    // if (!this.$route.query.index) {
    //   window.open(`/center/${this.school_code}/custom/party`, "_self")
    // }
    this.getCategoryList()
    this.getCourseList()
  },
  computed: {
    ...mapState({
      loginUserInfo: (state) => state.appsLogin.appsUserInfo,
    }),
  },
  methods: {
    // jumpList (index) {
    //   let findIndex = this.projectList.findIndex((i, j) => j == index)
    //   window.open(`/center/${this.school_code}/custom/party/project?index=${findIndex}`)
    // },
    // 获取课程分类列表
    getCategoryList () {
      //  getCategoryList getClassCategoryList
      services.getClassCategory({ root_id: 0, }).then(res => {
        if (res && res.code == '0000' && res.data && res.data.length > 0) {
          this.categoryData = [{ id: "", name: "全部" }, ...res.data]
        }
      })
    },

    // 获取课程列表
    getCourseList () {
      // getCourseList
      services.getUserCourseList({ page: this.currentPage, size: this.size, category_id: this.categoryId, }).then(res => {
        if (res && res.code == '0000' && res.data.items && res.data.items.length > 0) {
          this.courseData = res.data.items
          this.total = res.data.total
        }
      })
    },
    onChange (pageNumber) {
      this.currentPage = pageNumber;
      this.getCourseList()
    },

    // 切换分类ID
    async currentId (item) {
      this.categoryId = await item.id
      await this.getCourseList()
    },
    goClassDetails (item) {
      if (item.status != 3 && item.remaining_day != 0) {
        utils.redirect(this, `/${this.school_code}/hangke/base/${item.id}`, true);
      }
    },
  },
}
</script>

<style  lang="less" scoped>
* {
    font-family: Microsoft YaHei;
}
@keyframes zoomIn {
    0% {
        opacity: 0;
        -webkit-transform: scale3d(0.3, 0.3, 0.3);
        transform: scale3d(0.3, 0.3, 0.3);
    }
    50% {
        opacity: 1;
    }
}

.banner {
    width: 100%;
    height: 522px;
    position: relative;
    z-index: 10;
    background:url('../../assets/hangke/bg.jpg') no-repeat center/cover
}
.container {
    .header {
        width: 964px;
        height: 22px;
        margin: 0 auto;
    }
    .course {
        width: 1200px;
        margin: 0 auto;
        padding: 32px 0 10px;
        .header {
            background: url('../../assets/hangke/jidi.png') no-repeat center/cover;
            margin-bottom: 17px;
        }
        .collect {
            margin: 0 auto;
            width: 480px;
            height: 27px;
            background: linear-gradient(
                to left,
                #fff,
                rgba(237, 218, 177, 0.24),
                #fff
            );
            margin-bottom: 20px;
            font-size: 12px;
            color: #8e836b;
            text-align: center;
            line-height: 27px;
        }
        .category-list {
            display: flex;
            flex-wrap: wrap;
            margin-bottom: 17px;
            .item {
                line-height: 1;
                padding: 9px 22px;
                font-size: 14px;
                background: rgba(221,245,248, 0.5);
                margin-bottom: 10px;
                color: #9c9999;
                cursor: pointer;
                &:hover,
                &.active {
                    color: #ffffff;
                    background: #178586;
                }
                &:not(:last-child) {
                    margin-right: 19px;
                }
            }
        }
        .course-list {
            display: flex;
            align-items: center;
            justify-content: space-between;
            flex-wrap: wrap;
            .visible {
                display: inline-block;
                flex: 0 0 280px;
                visibility: hidden;
            }
            .item {
                cursor: pointer;
                width: 280px;
                margin-bottom: 27px;
                &:hover {
                    .item-cover {
                        img {
                            transform: scale(1.2);
                        }
                    }
                }
                .item-cover {
                    width: 280px;
                    height: 157px;
                    overflow: hidden;
                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                        transition: transform 0.5s;
                    }
                }
                .item-info {
                    width: 100%;
                    height: 70px;
                    background: #ffffff;
                    border: 1px solid #e2e2e3;
                    padding: 14px 14px 0;
                    .info-title {
                        height: 36px;
                        font-size: 14px;
                        color: #020718;
                        line-height: 18px;
                        margin-bottom: 15px;
                        span {
                            overflow: hidden;
                            text-overflow: ellipsis;
                            display: -webkit-box;
                            -webkit-box-orient: vertical;
                            -webkit-line-clamp: 2;
                        }
                    }
                    .info-other {
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        .category {
                            width: 145px;
                            height: 24px;
                            background: #fcf6f0;
                            text-align: center;
                            line-height: 24px;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            font-size: 12px;
                            color: #876f46;
                            padding: 0 14px;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                            overflow: hidden;
                        }
                        .time {
                            flex-shrink: 0;
                            font-size: 12px;
                            color: #9199a1;
                            &::before {
                                content: '';
                                display: inline-block;
                                margin-right: 4px;
                                vertical-align: -2px;
                                width: 12px;
                                height: 12px;
                                background: url('../../assets/custom/party/project/index/icon-time.png')
                                    no-repeat center/cover;
                            }
                        }
                    }
                }
            }
        }
    }
    .about {
        width: 100%;
        height: 120px;
        background: url('../../assets/custom/party/project/index/bg-04.png')
            no-repeat center/cover;
        .container {
            width: 1200px;
            margin: 0 auto;
            display: flex;
            align-items: center;
            justify-content: space-between;
            .label {
                width: 42px;
                height: 120px;
                background: #a8000c;
                font-weight: bold;
                font-size: 17px;
                color: #ffffff;
                letter-spacing: 2px;
                writing-mode: vertical-lr;
                text-align: center;
                line-height: 42px;
                margin-right: 26px;
            }
            .content {
                flex: 1;
                display: flex;
                justify-content: space-between;
                a {
                    width: 360px;
                    height: 96px;
                    overflow: hidden;
                    &:hover {
                        img {
                            scale: 1.2;
                        }
                    }
                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                        transition: scale 0.5s;
                    }
                }
            }
        }
    }
}
.fff {
    background: #fff;
}

</style>
<style>
.hangkeBase.pages {
  text-align: center;
}


.hangkeBase.pages .ant-pagination-item:focus, 
.hangkeBase.pages .ant-pagination-item:hover {
  border-color: #178586;
}
.hangkeBase.pages  .ant-pagination-item:focus a, 
.hangkeBase.pages  .ant-pagination-item:hover a {
  color: #178586;
}
.hangkeBase.pages .ant-pagination-prev:focus .ant-pagination-item-link, 
.hangkeBase.pages .ant-pagination-next:focus .ant-pagination-item-link, 
.hangkeBase.pages .ant-pagination-prev:hover .ant-pagination-item-link, 
.hangkeBase.pages .ant-pagination-next:hover .ant-pagination-item-link {
  border-color: #178586;
  color: #178586;
}
.hangkeBase.pages .ant-pagination-item-active {
  background: #178586;
  border: 1px solid #178586;
}
.hangkeBase.pages .ant-pagination-item-active a {
  background: #178586;
  color: #fff;
}
</style>


